import React, { useState, useEffect } from 'react';
import '../styles/Reports.css';
import { getReports } from '../services/api';

function Reports() {
  const [reportType, setReportType] = useState('clients');
  const [reportData, setReportData] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const data = await getReports(reportType);
        setReportData(data);
      } catch (err) {
        console.error('Failed to fetch report:', err);
      }
    };
    fetchReport();
  }, [reportType]);

  const handleExport = () => {
    const csv = reportData.map(item => Object.values(item).join(',')).join('\n');
    const headers = Object.keys(reportData[0]).join(',');
    const blob = new Blob([`${headers}\n${csv}`], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${reportType}_report.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="ap-reports">
      <h2 className="ap-reports-title">Reports</h2>
      <div className="ap-reports-controls">
        <select
          className="ap-report-select"
          value={reportType}
          onChange={(e) => setReportType(e.target.value)}
        >
          <option value="clients">Client Activity</option>
          <option value="projects">Project Status</option>
          <option value="payments">Financial Overview</option>
        </select>
        {reportData && <button className="ap-export-btn" onClick={handleExport}>Export CSV</button>}
      </div>
      {reportData && (
        <div className="ap-report-content">
          <h3 className="ap-report-subtitle">{reportType.charAt(0).toUpperCase() + reportType.slice(1)}</h3>
          <table className="ap-report-table">
            <thead>
              <tr>
                {Object.keys(reportData[0]).map(key => <th key={key}>{key}</th>)}
              </tr>
            </thead>
            <tbody>
              {reportData.map((item, index) => (
                <tr key={index}>
                  {Object.values(item).map((value, i) => <td key={i}>{value}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Reports;